<template>
  <v-list>
    <template v-for="menuItem in menu" :key="menuItem.path">
      <v-list-item
        v-bind="menuItem.disableNavigation?{}:bindLinks(menuItem)"
        @click="scrollContentTop"
        v-if="!menuItem.hiddenInTree"
      >
        <template
          #prepend
          v-if="menuItem.icon"
        >
          <!--          #2949ff #2eab90 teal-accent-4 cyan-accent-4 green-accent-3 -->
          <v-icon
            class="mr-n6"
            color="cyan-accent-4"
            size="24"
          >
            {{ menuItem.icon }}
          </v-icon>
        </template>
        {{ menuItem.name }}
        <v-chip
          v-if="menuItem.badge"
          size="x-small"
          color="primary"
          variant="tonal"
          class="ml-2"
        >
          {{ menuItem.badge }}
        </v-chip>
      </v-list-item>
      <template v-if="menuItem.children">
        <menu-tree :menu="menuItem.children" class="ml-4" />
      </template>
    </template>
  </v-list>
</template>

<script setup lang="ts">
import type { MenuItem } from '~~/shared/services/menu/MenuItem';
import { bindLinks, scrollContentTop } from '~~/shared/services/menu/MenuService';

const props = defineProps<{
  menu: MenuItem[];
}>();

</script>
